import { fetchDataDocs, fetchDetails } from "../../services/sharedViews.service";
import { actionTypes } from "../contants/actionTypes";
import { ensureArray, ensureJsonObject } from "../../utils/validateResponseApi";
import { callApi } from "../../services/api.service";
import { mergeArrays } from "../../utils/arrayUtils";


export const initState = (action) => ({
    type: actionTypes.resetInitState,
});

export const idUserAction = (idUserAction) => ({
    type: actionTypes.setIdUserAction,
    payload: idUserAction
});

//#region LOAD_ALL_DOCS
const getData = async (accessToken, variables, id_user_action) => {
    const response = await fetchDataDocs(accessToken, variables, id_user_action);
    return response.data;
}

export const loadAllDocs = (data) => ({
    type: actionTypes.loadAllDocs,
    payload: data
});

const setIsLoading = (data) => ({
    type: actionTypes.isLoadingLoadAllDocs,
    payload: data
});

export const getAllDocs = (accessToken, id_user_action, filters, pagination, append = false) => {
    return async (dispatch, getState) => {
        if (!append) dispatch(setIsLoading(true));
        dispatch(LoadData(actionTypes.filterAndPagination, { filters, pagination }));
        try {
            const docsData = await getData(accessToken, { filters, pagination, mode: 'SELECT' }, id_user_action);
            let mergedDocs = ensureArray(docsData) || [];
            if (append) {
                const currentDocs = getState().sharedViews.listAllDocs;
                mergedDocs = mergeArrays(currentDocs, mergedDocs);
            }
            dispatch(loadAllDocs(mergedDocs));
            try {
                const counterData = await getData(accessToken, { filters, pagination, mode: 'COUNTER' }, id_user_action);
                dispatch(LoadData(actionTypes.counter, counterData?.[0]?.count ?? mergedDocs.length));
            } catch (e) {
                dispatch(LoadData(actionTypes.counter, mergedDocs.length));
            }

        } catch (e) {
            console.error("ERROR getAllDocs", e);
            dispatch(loadAllDocs([]));
            dispatch(LoadData(actionTypes.counter, 0));
        } finally {
            dispatch(setIsLoading(false));
        }
    };
};
//#endregion

//#region SHARED DETAILS TABLE
export const getColumns = (accessToken, id) => {

    return (dispatch) => {
        callApi("user_select", "MENU_ID", { id_user_action: id }, accessToken, { findOne: 'true' })
            .then(({ data }) => {
                console.log('SudMenu ', data);
                const config = ensureJsonObject(data?.configuration);
                const table = ensureArray(config.table);
                const button = ensureArray(config.button);
                const infoSudmenu = {
                    configuration: config,
                    title: data.name,
                    description: data.description,
                    actions_label: config?.actions_label || ''
                };

                dispatch(loadConfiguration(button));
                dispatch(loadColumsTable(table));
                dispatch(LoadData(actionTypes.checkInTable, config?.table_check));
                dispatch(LoadData(actionTypes.infoSudMenu, infoSudmenu));
            }).catch((e) => {
                console.error('ERROR getColumns', e);
                dispatch(LoadData(actionTypes.checkInTable, false));
            }).finally(() => {
            });
    }
};

export const getDetails = (accessToken, id, variables) => {
    return (dispatch) => {
        dispatch(setIsLoadingDetails(true));
        fetchDetails(accessToken, id, variables)
            .then(({ data }) => {
                dispatch(LoadData(actionTypes.getListDetails, data ?? []));
            }).catch((e) => {
                console.log('error', e)
            }).finally(() => {
                dispatch(setIsLoadingDetails(false));
            });
    }
};

export const LoadData = (action, data) => ({
    type: action,
    payload: data
});

export const loadColumsTable = (data) => ({
    type: actionTypes.getColumnsTableDetails,
    payload: data
});

export const loadConfiguration = (data) => ({
    type: actionTypes.getConfigurationTableDetails,
    payload: data
});

const setIsLoadingDetails = (data) => ({
    type: actionTypes.isLoadingListDetails,
    payload: data
});
//#endregion